import { FC } from 'react'
import cn from 'classnames'

import style from '@src/components/Buy/Buy.module.scss'
import { DataPurchaseType } from '@src/types/user'

export const Buy: FC<DataPurchaseType> = ({
  date, amount, number, awardBonus, usedBonus,
}) => (
  <div className={cn(style.buy, 'borderStyle')}>
    <div className={style.buyContainer}>
      <div className={style.date}>
        <div className={style.title}>Дата</div>
        <div className={style.description}>
          <div className={style.value}>{date}</div>
        </div>
      </div>
      <div className={style.checkNumber}>
        <div className={style.title}>№ Чека</div>
        <div className={style.description}>
          <div className={style.value}>{number}</div>
        </div>
      </div>
      <div className={style.accrued}>
        <div className={style.title}>Начислено</div>
        <div className={style.description}>
          <div className={style.value}>
            {awardBonus ? `+${awardBonus}` : awardBonus}
          </div>
          Баллов
        </div>
      </div>
      <div className={style.debited}>
        <div className={style.title}>Списано</div>
        <div className={style.description}>
          <div className={style.value}>
            {usedBonus ? `-${usedBonus}` : usedBonus}
          </div>
          Баллов
        </div>
      </div>
      <div className={style.summ}>
        <div className={style.title}>Сумма</div>
        <div className={style.description}>
          <div className={style.value}>{amount}</div>
          {' '}
          руб.
        </div>
      </div>
    </div>
  </div>
)
